export default __webpack_public_path__ + "static/media/onlineshopping.9b2f0643.gif";